export default [
  {
    height: 1366,
    width: 1024,
    pixelRatio: 2,
    devices: ['12.9" iPad Pro'],
  },
  {
    height: 1194,
    width: 834,
    pixelRatio: 2,
    devices: ['11" iPad Pro', '10.5" iPad Pro'],
  },
  {
    height: 1112,
    width: 834,
    pixelRatio: 2,
    devices: ['10.5" iPad Air'],
  },
  {
    height: 1080,
    width: 810,
    pixelRatio: 2,
    devices: ['10.2" iPad'],
  },
  {
    height: 1080,
    width: 820,
    pixelRatio: 2,
    devices: ['10.9" iPad Air 4'],
  },
  {
    height: 1024,
    width: 768,
    pixelRatio: 2,
    devices: ['9.7" iPad Pro', '7.9" iPad mini', '9.7" iPad Air', '9.7" iPad'],
  },
  {
    height: 926,
    width: 428,
    pixelRatio: 3,
    devices: ["iPhone 12 Pro Max"],
  },
  {
    height: 896,
    width: 414,
    pixelRatio: 3,
    devices: ["iPhone 11 Pro Max", "iPhone Xs Max"],
  },
  {
    height: 844,
    width: 390,
    pixelRatio: 3,
    devices: ["iPhone 12 Pro", "iPhone 12"],
  },
  {
    height: 812,
    width: 375,
    pixelRatio: 3,
    devices: ["iPhone 12 Mini", "iPhone 11 Pro", "iPhone Xs", "iPhone X"],
  },
  {
    height: 736,
    width: 414,
    pixelRatio: 3,
    devices: [
      "iPhone 8 Plus",
      "iPhone 7 Plus",
      "iPhone 6s Plus",
      "iPhone 6 Plus",
    ],
  },
  {
    height: 896,
    width: 414,
    pixelRatio: 2,
    devices: ["iPhone 11", "iPhone XR"],
  },
  {
    height: 667,
    width: 375,
    pixelRatio: 2,
    devices: ["iPhone SE 2nd", "iPhone 8", "iPhone 7", "iPhone 6s", "iPhone 6"],
  },
  {
    height: 568,
    width: 320,
    pixelRatio: 2,
    devices: ["iPhone SE 1st"],
  },
];
